import React, { MouseEventHandler, useMemo } from 'react';
import styled from 'styled-components/macro';
import { PurchaseButton } from '../buttons/PurchaseButton';
import { PurchaseFeaturesPanel, Subtitle } from './PurchaseFeaturesPanel';
import { DownloadButton, DownloadIconWrapper } from './DownloadButton';

type Props = {
  galleryCount: number;
  movieCount?: number;
  onPurchase: MouseEventHandler<HTMLButtonElement>;
  startingPrice: string;
  hasPPS?: boolean;
  has4kResolution?: boolean;
  downloadsDisabled: boolean;
};

export const MovieRegularPurchasePanel = (props: Props) => {
  const { galleryCount, movieCount, onPurchase, startingPrice, hasPPS = true, has4kResolution } = props;

  const featuresList = useMemo(
    () => [
      `${galleryCount} Photo Galleries`,
      movieCount ? `${movieCount} Erotic Scenes` : 'Erotic Scenes',
      'Daily Updates',
      'Mobile Friendly',
      "World's Finest Models",
      'No DRM',
      'Unlimited Streaming',
      has4kResolution ? 'HD & UHD 4K Films' : 'Live Shows',
    ],
    [galleryCount, has4kResolution, movieCount],
  );

  return (
    <PurchaseFeaturesPanel
      headline="THE HIGHEST QUALITY OF EXCLUSIVE CONTENT"
      purchaseFeatures={featuresList}
      subtitle="What are you waiting for?"
    >
      <StyledPurchaseButton topTitle="Access All Movies Instantly" />
      {hasPPS && !props.downloadsDisabled && (
        <>
          <Subtitle>Also Available</Subtitle>
          <StyledDownloadButton onClick={onPurchase}>{`Download from ${startingPrice}`}</StyledDownloadButton>
        </>
      )}
      <Subtitle>MEMBERS GET</Subtitle>
    </PurchaseFeaturesPanel>
  );
};

const StyledDownloadButton = styled(DownloadButton)`
  font-size: 0.875rem;
  font-weight: bold;
  display: inline-flex;
  color: #000;

  :hover {
    color: #000;
  }

  ${DownloadIconWrapper} {
    padding: 0px 8px;
    font-size: 1.8rem;
  }
`;

const StyledPurchaseButton = styled(PurchaseButton)`
  font-weight: bold;
  position: relative;
  text-align: center;
  margin: 5px auto;
  padding: 10px;
  font-size: 0.875rem;
  transition: opacity 0.3s;
  max-width: 400px;

  :hover {
    opacity: 0.9;
  }

  .icon {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    text-shadow: none;
  }
`;
